class ApiHelper {
  static fetchData = async (url, token) => {
    try {
      const response = await fetch(
        url,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }
      );

      if (response.status === 401) {
        throw new Error('Unauthorized: Check your Bearer token');
      }

      if (!response.ok) {
        throw new Error(`Failed to fetch data. Status: ${response.status}`);
      }

      var data = await response.json();

      if (response.status === 404) {
        console.log("here at empty");
        data.data = [];
      }

      
      return data;

    } catch (error) {
      console.error('Error fetching data:', error.message);
      throw error;
    }
  };
}

export default ApiHelper;
